import { useMutation } from '@tanstack/react-query';
import { apiClient } from './client';

export function useLinkiDraft() {
  return useMutation({
    mutationFn: async (params: { prompt: string; context: Record<string, unknown>; tone?: string; step_type?: string }) => {
      const { data } = await apiClient.post('/linki/draft', params);
      return data.data as { text: string };
    },
  });
}

export function useLinkiRewrite() {
  return useMutation({
    mutationFn: async (params: { current_text: string; instruction: string }) => {
      const { data } = await apiClient.post('/linki/rewrite', params);
      return data.data as { text: string };
    },
  });
}
